// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.web-analytics-dashboard-with-data {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  height: 100%;
  max-height: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 0.25rem;
  overflow: hidden;
}
@media (max-width: 600px) {
  .web-analytics-dashboard-with-data {
    max-width: 100%;
    padding: 0 0.25rem;
  }
}
.web-analytics-dashboard-with-data__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0.75rem 0.75rem 0;
  flex-wrap: wrap;
  flex-shrink: 0;
  margin-bottom: 16px;
}
@media (max-width: 600px) {
  .web-analytics-dashboard-with-data__toolbar {
    padding: 0.75rem 0.75rem 0;
    gap: 0.75rem;
    flex-wrap: wrap;
  }
}
.web-analytics-dashboard-with-data__heading {
  min-width: 0;
  padding-top: 2px;
  margin-top: -15px;
}
.web-analytics-dashboard-with-data__title {
  margin: 0;
  font-size: 30px;
  line-height: 1.2;
  font-weight: 700;
  color: #000000;
  font-family: "Open Sans", sans-serif;
}
@media (max-width: 900px) {
  .web-analytics-dashboard-with-data__title {
    font-size: 24px;
  }
}
.web-analytics-dashboard-with-data__subtitle {
  margin: 6px 0 0;
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  color: #000000;
  line-height: 1.4;
}
.web-analytics-dashboard-with-data__date-range {
  margin-inline-start: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@media (max-width: 600px) {
  .web-analytics-dashboard-with-data__date-range {
    margin-inline-start: 0;
    width: 100%;
  }
}
.web-analytics-dashboard-with-data__narrative {
  flex-shrink: 0;
  padding: 0 0.75rem;
  margin-bottom: 16px;
}
@media (max-width: 600px) {
  .web-analytics-dashboard-with-data__narrative {
    padding: 0 0.75rem;
    margin-bottom: 14px;
  }
}
.web-analytics-dashboard-with-data__loading {
  font-size: 13px;
  color: #1f4aa8;
  font-weight: 500;
}
.web-analytics-dashboard-with-data__error {
  font-size: 12px;
  color: #e5533d;
  font-style: italic;
}
.web-analytics-dashboard-with-data__content {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-gutter: stable;
}
.web-analytics-dashboard-with-data__unified-loading {
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
}
.web-analytics-dashboard-with-data__no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  font-size: 15px;
  color: #8a9bb8;
  font-weight: 500;
}

.web-analytics-kpi-dashboard {
  padding: 1rem 0.5rem;
  max-width: 100%;
  margin: 0 auto;
}
@media (max-width: 600px) {
  .web-analytics-kpi-dashboard {
    padding: 1rem 0.5rem;
  }
}
.web-analytics-kpi-dashboard--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}
.web-analytics-kpi-dashboard__no-data {
  font-size: 15px;
  color: #8a9bb8;
  font-weight: 500;
}
.web-analytics-kpi-dashboard .kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 1fr;
  align-items: stretch;
  gap: 1.25rem;
}
@media (max-width: 1200px) {
  .web-analytics-kpi-dashboard .kpi-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 600px) {
  .web-analytics-kpi-dashboard .kpi-grid {
    grid-template-columns: 1fr;
  }
}
.web-analytics-kpi-dashboard .kpi-grid .dashboard-metric-tile {
  min-height: 130px;
  height: 100%;
}

.kpi-card {
  background: #ffffff;
  border: 1px solid #dbe4f0;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
  min-height: 160px;
  height: 100%;
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
  isolation: isolate;
}
.kpi-card:hover {
  box-shadow: 0 4px 12px rgba(16, 24, 40, 0.08);
  border-color: #dbe4f0;
  z-index: 4;
}
.kpi-card__main {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  flex: 1 1;
  min-height: 0;
}
.kpi-card__left {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
}
.kpi-card__title {
  font-size: 12px;
  font-weight: 700;
  color: #667085;
  margin-bottom: 0.5rem;
  line-height: 1.25;
  min-height: 1.25em;
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.kpi-card__title-text {
  min-width: auto;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
  display: inline;
  max-width: none;
}
.kpi-card__title-help {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #9cb4db;
  color: #5f7fb5;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  flex-shrink: 0;
  background: transparent;
  padding: 0;
}
.kpi-card__title-help--interactive {
  cursor: help;
}
.kpi-card__title-help-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.kpi-card__definition-tooltip {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 420px;
  max-width: min(420px, 100vw - 40px);
  border-radius: 12px;
  border: 1px solid #d9e3f2;
  background: #fff;
  box-shadow: 0 10px 24px rgba(14, 30, 62, 0.16);
  padding: 14px;
  z-index: 8;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-2px);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
  pointer-events: none;
}
.kpi-card__title-help-wrap:hover .kpi-card__definition-tooltip, .kpi-card__title-help-wrap:focus-within .kpi-card__definition-tooltip {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.kpi-card__definition-text {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  color: #6A7282;
}
.kpi-card__definition-formula-box {
  border-radius: 10px;
  background: #e8f0fb;
  border-inline-start: 4px solid #1f5da8;
  padding: 10px 12px 12px;
}
.kpi-card__definition-formula-title {
  margin: 0 0 4px;
  font-size: 13px;
  line-height: 1;
  color: #6A7282;
  font-weight: 700;
}
.kpi-card__definition-formula {
  margin: 0;
  font-size: 11px;
  line-height: 1.35;
  color: #6A7282;
  font-weight: 500;
}
.kpi-card__value {
  font-size: 24px;
  font-weight: 700;
  color: #101828;
  margin-bottom: 0.35rem;
  line-height: 1.2;
  min-height: 1.44em;
}
.kpi-card__period {
  font-size: 13px;
  color: #667085;
  margin-bottom: 0.35rem;
  min-height: 1.4em;
  white-space: nowrap;
  font-weight: 500;
}
.kpi-card__change {
  font-size: 13px;
  font-weight: 700;
}
.kpi-card__change--positive {
  color: #28a745;
}
.kpi-card__change--negative {
  color: #e53935;
}
.kpi-card__right {
  flex: 0 0 42%;
  min-width: 0;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 10px;
}
.kpi-card__chart {
  width: 100%;
  height: 56px;
  min-height: 56px;
  margin-top: auto;
}
.kpi-card__icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #eef4ff;
  color: #356fb6;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.kpi-card__hover-panel {
  display: flex;
  width: 250px;
  height: 140px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #d7e1ef;
  box-shadow: 0 6px 14px rgba(14, 30, 62, 0.12);
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 78px;
  z-index: 3;
}
.kpi-card__hover-bar {
  width: 4px;
  background: #1f4aa8;
  border-radius: 0;
}
.kpi-card__hover-content {
  padding: 12px 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.kpi-card__hover-title {
  font-size: 12px;
  font-weight: 600;
  color: #1f4aa8;
}
.kpi-card__hover-value {
  font-size: 16px;
  font-weight: 700;
  color: #1f4aa8;
  line-height: 1.2;
}
.kpi-card__hover-period {
  font-size: 11px;
  font-weight: 500;
  color: #1f4aa8;
  margin-bottom: 6px;
}
.kpi-card__hover-divider {
  width: 100%;
  height: 0;
  border: none;
  border-top: 1px dashed #cfd9ea;
  margin-bottom: 6px;
}
.kpi-card__hover-mom-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.kpi-card__hover-mom-label {
  font-size: 11px;
  color: #8a9bb8;
}
.kpi-card__hover-change {
  font-size: 12px;
  font-weight: 600;
}
.kpi-card__hover-change--positive {
  color: #1fa971;
}
.kpi-card__hover-change--negative {
  color: #e5533d;
}
.kpi-card__hover-comparison {
  margin-top: 6px;
  font-size: 11px;
  color: #8a9bb8;
}

.web-analytics-kpi-dashboard .recharts-cartesian-grid-horizontal line,
.web-analytics-kpi-dashboard .recharts-cartesian-grid-vertical line {
  stroke: transparent;
}

.kpi-graph-tooltip {
  display: flex;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 10px rgba(14, 30, 62, 0.12);
  overflow: hidden;
  padding: 0;
  margin: 0;
  border: 1px solid #d7e1ef;
  min-width: 200px;
}
.kpi-graph-tooltip__bar {
  width: 3px;
  flex-shrink: 0;
  background: #2c68ad;
}
.kpi-graph-tooltip__content {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: start;
}
.kpi-graph-tooltip__label {
  font-size: 12px;
  font-weight: 700;
  color: #2c68ad;
  margin-bottom: 2px;
  margin-top: 0;
}
.kpi-graph-tooltip__value {
  font-size: 12px;
  font-weight: 700;
  color: #2c68ad;
  margin-bottom: 2px;
}
.kpi-graph-tooltip__period {
  font-size: 10px;
  color: #2c68ad;
  margin-bottom: 6px;
  font-weight: 700;
}
.kpi-graph-tooltip__divider {
  width: 100%;
  border: none;
  border-top: 1px dashed #2c68ad;
  margin: 4px 0 6px;
}
.kpi-graph-tooltip__mom-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.kpi-graph-tooltip__mom-label {
  font-size: 11px;
  color: #2c68ad;
  font-weight: 400;
}
.kpi-graph-tooltip__mom-value {
  font-size: 11px;
  font-weight: 600;
}
.kpi-graph-tooltip__mom-value--positive {
  color: #28a745;
}
.kpi-graph-tooltip__mom-value--negative {
  color: #e53935;
}

.web-analytics-kpi-dashboard .recharts-tooltip-wrapper {
  outline: none;
  z-index: 60;
  transform: translate(10px, calc(-100% + 14px)) !important;
  transform-origin: left bottom;
  pointer-events: none;
}

/* 4-column KPI grid (desktop): right-half cards open inward (to the left). */
@media (min-width: 1201px) {
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n) .recharts-tooltip-wrapper,
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n-1) .recharts-tooltip-wrapper {
    transform: translate(calc(-100% - 10px), calc(-100% + 14px)) !important;
    transform-origin: right bottom;
  }
}
/* 2-column KPI grid (tablet/small laptop): second column opens inward. */
@media (min-width: 601px) and (max-width: 1200px) {
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n) .recharts-tooltip-wrapper {
    transform: translate(calc(-100% - 10px), calc(-100% + 14px)) !important;
    transform-origin: right bottom;
  }
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n+1) .recharts-tooltip-wrapper {
    transform: translate(8px, calc(-100% + 14px)) !important;
    transform-origin: left bottom;
  }
}
/* 1-column KPI grid (mobile): keep tooltip inside with compact offset. */
@media (max-width: 600px) {
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card .recharts-tooltip-wrapper {
    transform: translate(6px, calc(-100% + 22px)) !important;
    transform-origin: left bottom;
  }
}
.web-analytics-kpi-dashboard .kpi-graph-tooltip {
  z-index: 10;
  pointer-events: none;
}

.web-analytics-kpi-dashboard .recharts-default-tooltip {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
}

.kpi-card__hover-title {
  font-size: 12px;
  font-weight: 700;
  color: #2c68ad;
}

.kpi-card__hover-value {
  font-size: 12px;
  font-weight: 700;
  color: #2c68ad;
}

.kpi-card__hover-period {
  font-size: 10px;
  color: #2c68ad;
}

.kpi-card__hover-divider {
  border-top: 1px dashed #2c68ad;
}

.kpi-card__hover-mom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
}

.kpi-card__hover-mom-label {
  color: #2c68ad;
}

.kpi-card__hover-change {
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
}

.kpi-card__hover-change--positive {
  color: #16a34a;
}

.kpi-card__hover-change--negative {
  color: #dc2626;
}

.kpi-card__hover-comparison {
  font-size: 10px;
  color: #2c68ad;
  font-weight: 700;
  margin-top: 0;
}

.kpi-card__hover-content .kpi-card__hover-comparison:last-child {
  margin-bottom: 6px;
}

/* Keep KPI hover panel and sparkline tooltip inside viewport on medium/small screens */
.web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n) .kpi-card__hover-panel {
  left: auto;
  right: 0;
}

@media (max-width: 1000px) {
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card .kpi-card__hover-panel {
    width: min(250px, 100vw - 190px);
  }
}
/* Keep ? tooltip inside viewport by opening inward on right-side cards */
.web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n) .kpi-card__definition-tooltip {
  left: auto;
  right: 0;
}

@media (min-width: 1201px) {
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n) .kpi-card__definition-tooltip,
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n-1) .kpi-card__definition-tooltip {
    left: auto;
    right: 0;
  }
}
@media (max-width: 600px) {
  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card .kpi-card__definition-tooltip {
    left: 0;
    right: auto;
    max-width: calc(100vw - 28px);
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/webAnalytics/components/KPI/KPIDashboard.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAGE;EAbF;IAcI,eAAA;IACA,kBAAA;EAAF;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,0BAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAAJ;AAEI;EAVF;IAWI,0BAAA;IACA,YAAA;IACA,eAAA;EACJ;AACF;AAEE;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;AAGE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cC1BQ;ED2BR,oCCsKU;ADvKd;AAGI;EARF;IASI,eAAA;EAAJ;AACF;AAGE;EACE,eAAA;EACA,eAAA;EACA,oCC4JU;ED3JV,cCtCQ;EDuCR,gBAAA;AADJ;AAIE;EACE,yBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAFJ;AAII;EANF;IAOI,sBAAA;IACA,WAAA;EADJ;AACF;AAIE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAII;EALF;IAMI,kBAAA;IACA,mBAAA;EADJ;AACF;AAIE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAHJ;AAME;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,wBAAA;AAJJ;AAOE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AANJ;;AAUA;EACE,oBAAA;EACA,eAAA;EACA,cAAA;AAPF;AASE;EALF;IAMI,oBAAA;EANF;AACF;AAQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AANJ;AASE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAPJ;AAUE;EACE,aAAA;EACA,qCAAA;EACA,mBAAA;EACA,oBAAA;EACA,YAAA;AARJ;AAUI;EAPF;IAQI,qCAAA;EAPJ;AACF;AAQI;EAVF;IAWI,0BAAA;EALJ;AACF;AAOI;EACE,iBAAA;EACA,YAAA;AALN;;AAUA;EACE,mBCjKM;EDkKN,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,wDAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAPF;AASE;EACE,6CAAA;EACA,qBAAA;EACA,UAAA;AAPJ;AAUE;EACE,aAAA;EACA,oBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;AARJ;AAWE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,sBAAA;EACA,yBAAA;AAVJ;AAaE;EACE,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAXJ;AAcE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;AAZJ;AAeE;EACE,YAAA;AAbJ;AAgBE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAdJ;AAiBE;EACE,kBAAA;EACA,qBAAA;EACA,OAAA;EACA,YAAA;EACA,mCAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,8CAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,2EAAA;EACA,oBAAA;AAfJ;AAkBE;EAEE,UAAA;EACA,mBAAA;EACA,wBAAA;AAjBJ;AAoBE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,mBAAA;EACA,sCAAA;EACA,uBAAA;AAnBJ;AAsBE;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,SAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AArBJ;AAwBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,eAAA;EACA,gBAAA;AAxBJ;AA0BI;EACE,cCrTI;AD6RV;AA2BI;EACE,cC5TG;ADmST;AA6BE;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,SAAA;AA3BJ;AA8BE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AA5BJ;AA+BE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA7BJ;AAiCE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBCpXI;EDqXJ,kBAAA;EACA,yBAAA;EACA,6CAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,UAAA;AA/BJ;AAkCE;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;AAhCJ;AAmCE;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjCJ;AAoCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAlCJ;AAqCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAnCJ;AAsCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AApCJ;AAuCE;EACE,WAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;AArCJ;AAwCE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAtCJ;AAyCE;EACE,eAAA;EACA,cAAA;AAvCJ;AA0CE;EACE,eAAA;EACA,gBAAA;AAxCJ;AA0CI;EACE,cAAA;AAxCN;AA2CI;EACE,cAAA;AAzCN;AA6CE;EACE,eAAA;EACA,eAAA;EACA,cAAA;AA3CJ;;AAgDA;;EAEE,mBAAA;AA7CF;;AAiDA;EACE,aAAA;EACA,mBChdM;EDidN,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AA9CF;AAgDE;EACE,UAAA;EACA,cAAA;EACA,mBCveY;ADybhB;AAiDE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AA/CJ;AAkDE;EACE,eAAA;EACA,gBAAA;EACA,cCrfY;EDsfZ,kBAAA;EACA,aAAA;AAhDJ;AAmDE;EACE,eAAA;EACA,gBAAA;EACA,cC7fY;ED8fZ,kBAAA;AAjDJ;AAoDE;EACE,eAAA;EACA,cCngBY;EDogBZ,kBAAA;EACA,gBAAA;AAlDJ;AAqDE;EACE,WAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;AAnDJ;AAsDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AApDJ;AAuDE;EACE,eAAA;EACA,cCxhBY;EDyhBZ,gBAAA;AArDJ;AAwDE;EACE,eAAA;EACA,gBAAA;AAtDJ;AAwDI;EACE,cClgBI;AD4cV;AAyDI;EACE,cCzgBG;ADkdT;;AA6DA;EACE,aAAA;EACA,WAAA;EACA,yDAAA;EACA,6BAAA;EACA,oBAAA;AA1DF;;AA6DA,6EAAA;AACA;EACE;;IAEE,uEAAA;IACA,8BAAA;EA1DF;AACF;AA6DA,yEAAA;AACA;EACE;IACE,uEAAA;IACA,8BAAA;EA3DF;EA8DA;IACE,wDAAA;IACA,6BAAA;EA5DF;AACF;AA+DA,yEAAA;AACA;EACE;IACE,wDAAA;IACA,6BAAA;EA7DF;AACF;AAgEA;EACE,WAAA;EACA,oBAAA;AA9DF;;AAiEA;EACE,qBAAA;EACA,kCAAA;EACA,uBAAA;AA9DF;;AAiEA;EACE,eCtYa;EDuYb,gBAAA;EACA,cC/lBc;ADiiBhB;;AAiEA;EACE,eC5Ya;ED6Yb,gBAAA;EACA,cCrmBc;ADuiBhB;;AAiEA;EACE,eCnZa;EDoZb,cC1mBc;AD4iBhB;;AAiEA;EACE,8BAAA;AA9DF;;AAiEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eC/Za;ADiWf;;AAiEA;EACE,cCznBc;AD2jBhB;;AAiEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eC3aa;AD6Wf;;AAiEA;EACE,cAAA;AA9DF;;AAiEA;EACE,cAAA;AA9DF;;AAiEA;EACE,eCvba;EDwbb,cC9oBc;ED+oBd,gBAAA;EACA,aAAA;AA9DF;;AAiEA;EACE,kBAAA;AA9DF;;AAiEA,uFAAA;AACA;EACE,UAAA;EACA,QAAA;AA9DF;;AAiEA;EACE;IACE,gCAAA;EA9DF;AACF;AAiEA,yEAAA;AACA;EACE,UAAA;EACA,QAAA;AA/DF;;AAkEA;EACE;;IAEE,UAAA;IACA,QAAA;EA/DF;AACF;AAkEA;EACE;IACE,OAAA;IACA,WAAA;IACA,6BAAA;EAhEF;AACF","sourcesContent":["@import \"../../../../styles/variables\";\n\n.web-analytics-dashboard-with-data {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 0.25rem;\n  overflow: hidden;\n\n  @media (max-width: 600px) {\n    max-width: 100%;\n    padding: 0 0.25rem;\n  }\n\n  &__toolbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 0.75rem 0.75rem 0;\n    flex-wrap: wrap;\n    flex-shrink: 0;\n    margin-bottom: 16px;\n\n    @media (max-width: 600px) {\n      padding: 0.75rem 0.75rem 0;\n      gap: 0.75rem;\n      flex-wrap: wrap;\n    }\n  }\n\n  &__heading {\n    min-width: 0;\n    padding-top: 2px;\n    margin-top: -15px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 30px;\n    line-height: 1.2;\n    font-weight: 700;\n    color: $text-dark;\n    font-family: $font-family;\n\n    @media (max-width: 900px) {\n      font-size: 24px;\n    }\n  }\n\n  &__subtitle {\n    margin: 6px 0 0;\n    font-size: 13px;\n    font-family: $font-family;\n    color: $text-dark;\n    line-height: 1.4;\n  }\n\n  &__date-range {\n    margin-inline-start: auto;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n\n    @media (max-width: 600px) {\n      margin-inline-start: 0;\n      width: 100%;\n    }\n  }\n\n  &__narrative {\n    flex-shrink: 0;\n    padding: 0 0.75rem;\n    margin-bottom: 16px;\n\n    @media (max-width: 600px) {\n      padding: 0 0.75rem;\n      margin-bottom: 14px;\n    }\n  }\n\n  &__loading {\n    font-size: 13px;\n    color: #1f4aa8;\n    font-weight: 500;\n  }\n\n  &__error {\n    font-size: 12px;\n    color: #e5533d;\n    font-style: italic;\n  }\n\n  &__content {\n    position: relative;\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-gutter: stable;\n  }\n\n  &__unified-loading {\n    z-index: 10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 280px;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 8px;\n  }\n\n  &__no-data {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 280px;\n    font-size: 15px;\n    color: #8a9bb8;\n    font-weight: 500;\n  }\n}\n\n.web-analytics-kpi-dashboard {\n  padding: 1rem 0.5rem;\n  max-width: 100%;\n  margin: 0 auto;\n\n  @media (max-width: 600px) {\n    padding: 1rem 0.5rem;\n  }\n\n  &--empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 120px;\n  }\n\n  &__no-data {\n    font-size: 15px;\n    color: #8a9bb8;\n    font-weight: 500;\n  }\n\n  .kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    grid-auto-rows: 1fr;\n    align-items: stretch;\n    gap: 1.25rem;\n\n    @media (max-width: 1200px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    @media (max-width: 600px) {\n      grid-template-columns: 1fr;\n    }\n\n    .dashboard-metric-tile {\n      min-height: 130px;\n      height: 100%;\n    }\n  }\n}\n\n.kpi-card {\n  background: $white;\n  border: 1px solid #dbe4f0;\n  border-radius: 12px;\n  padding: 18px 20px;\n  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.06);\n  transition: box-shadow 0.2s ease, border-color 0.2s ease;\n  min-height: 160px;\n  height: 100%;\n  position: relative;\n  overflow: visible;\n  display: flex;\n  flex-direction: column;\n  isolation: isolate;\n\n  &:hover {\n    box-shadow: 0 4px 12px rgba(16, 24, 40, 0.08);\n    border-color: #dbe4f0;\n    z-index: 4;\n  }\n\n  &__main {\n    display: flex;\n    align-items: stretch;\n    gap: 0.5rem;\n    flex: 1;\n    min-height: 0;\n  }\n\n  &__left {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    position: relative;\n  }\n\n  &__title {\n    font-size: 12px;\n    font-weight: 700;\n    color: #667085;\n    margin-bottom: 0.5rem;\n    line-height: 1.25;\n    min-height: 1.25em;\n    display: inline-flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    gap: 8px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n  }\n\n  &__title-text {\n    min-width: auto;\n    white-space: nowrap;\n    overflow: visible;\n    text-overflow: clip;\n    display: inline;\n    max-width: none;\n  }\n\n  &__title-help {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 14px;\n    height: 14px;\n    border-radius: 50%;\n    border: 1px solid #9cb4db;\n    color: #5f7fb5;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1;\n    flex-shrink: 0;\n    background: transparent;\n    padding: 0;\n  }\n\n  &__title-help--interactive {\n    cursor: help;\n  }\n\n  &__title-help-wrap {\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n  }\n\n  &__definition-tooltip {\n    position: absolute;\n    top: calc(100% + 8px);\n    left: 0;\n    width: 420px;\n    max-width: min(420px, calc(100vw - 40px));\n    border-radius: 12px;\n    border: 1px solid #d9e3f2;\n    background: #fff;\n    box-shadow: 0 10px 24px rgba(14, 30, 62, 0.16);\n    padding: 14px;\n    z-index: 8;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-2px);\n    transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;\n    pointer-events: none;\n  }\n\n  &__title-help-wrap:hover &__definition-tooltip,\n  &__title-help-wrap:focus-within &__definition-tooltip {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n  }\n\n  &__definition-text {\n    margin: 0 0 12px;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.35;\n    color: #6A7282;\n  }\n\n  &__definition-formula-box {\n    border-radius: 10px;\n    background: #e8f0fb;\n    border-inline-start: 4px solid #1f5da8;\n    padding: 10px 12px 12px;\n  }\n\n  &__definition-formula-title {\n    margin: 0 0 4px;\n    font-size: 13px;\n    line-height: 1;\n    color: #6A7282;\n    font-weight: 700;\n  }\n\n  &__definition-formula {\n    margin: 0;\n    font-size: 11px;\n    line-height: 1.35;\n    color: #6A7282;\n    font-weight: 500;\n  }\n\n  &__value {\n    font-size: 24px;\n    font-weight: 700;\n    color: #101828;\n    margin-bottom: 0.35rem;\n    line-height: 1.2;\n    min-height: 1.44em;\n  }\n\n  &__period {\n    font-size: 13px;\n    color: #667085;\n    margin-bottom: 0.35rem;\n    min-height: 1.4em;\n    white-space: nowrap;\n    font-weight: 500;\n  }\n\n  &__change {\n    font-size: 13px;\n    font-weight: 700;\n\n    &--positive {\n      color: $success;\n    }\n\n    &--negative {\n      color: $danger;\n    }\n  }\n\n  &__right {\n    flex: 0 0 42%;\n    min-width: 0;\n    align-self: stretch;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    justify-content: flex-start;\n    gap: 10px;\n  }\n\n  &__chart {\n    width: 100%;\n    height: 56px;\n    min-height: 56px;\n    margin-top: auto;\n  }\n\n  &__icon {\n    width: 42px;\n    height: 42px;\n    border-radius: 12px;\n    background: #eef4ff;\n    color: #356fb6;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n  }\n\n  // Hover panel: tooltip-style box over left area\n  &__hover-panel {\n    display: flex;\n    width: 250px;\n    height: 140px;\n    background: $white;\n    border-radius: 6px;\n    border: 1px solid #d7e1ef;\n    box-shadow: 0 6px 14px rgba(14, 30, 62, 0.12);\n    overflow: hidden;\n    position: absolute;\n    left: 0;\n    top: 78px;\n    z-index: 3;\n  }\n\n  &__hover-bar {\n    width: 4px;\n    background: #1f4aa8;\n    border-radius: 0;\n  }\n\n  &__hover-content {\n    padding: 12px 14px 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n  }\n\n  &__hover-title {\n    font-size: 12px;\n    font-weight: 600;\n    color: #1f4aa8;\n  }\n\n  &__hover-value {\n    font-size: 16px;\n    font-weight: 700;\n    color: #1f4aa8;\n    line-height: 1.2;\n  }\n\n  &__hover-period {\n    font-size: 11px;\n    font-weight: 500;\n    color: #1f4aa8;\n    margin-bottom: 6px;\n  }\n\n  &__hover-divider {\n    width: 100%;\n    height: 0;\n    border: none;\n    border-top: 1px dashed #cfd9ea;\n    margin-bottom: 6px;\n  }\n\n  &__hover-mom-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  &__hover-mom-label {\n    font-size: 11px;\n    color: #8a9bb8;\n  }\n\n  &__hover-change {\n    font-size: 12px;\n    font-weight: 600;\n\n    &--positive {\n      color: #1fa971;\n    }\n\n    &--negative {\n      color: #e5533d;\n    }\n  }\n\n  &__hover-comparison {\n    margin-top: 6px;\n    font-size: 11px;\n    color: #8a9bb8;\n  }\n}\n\n// Recharts sparkline: hide axes and keep chart minimal\n.web-analytics-kpi-dashboard .recharts-cartesian-grid-horizontal line,\n.web-analytics-kpi-dashboard .recharts-cartesian-grid-vertical line {\n  stroke: transparent;\n}\n\n// Graph tooltip (on hover over sparkline): white box, blue left bar, MoM %\n.kpi-graph-tooltip {\n  display: flex;\n  background: $white;\n  border-radius: 4px;\n  box-shadow: 0 4px 10px rgba(14, 30, 62, 0.12);\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #d7e1ef;\n  min-width: 200px;\n\n  &__bar {\n    width: 3px;\n    flex-shrink: 0;\n    background: $brand-primary;\n  }\n\n  &__content {\n    padding: 12px 14px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: start;\n  }\n\n  &__label {\n    font-size: 12px;\n    font-weight: 700;\n    color: $brand-primary;\n    margin-bottom: 2px;\n    margin-top: 0;\n  }\n\n  &__value {\n    font-size: 12px;\n    font-weight: 700;\n    color: $brand-primary;\n    margin-bottom: 2px;\n  }\n\n  &__period {\n    font-size: 10px;\n    color: $brand-primary;\n    margin-bottom: 6px;\n    font-weight: 700;\n  }\n\n  &__divider {\n    width: 100%;\n    border: none;\n    border-top: 1px dashed $brand-primary;\n    margin: 4px 0 6px;\n  }\n\n  &__mom-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n  }\n\n  &__mom-label {\n    font-size: 11px;\n    color: $brand-primary;\n    font-weight: 400;\n  }\n\n  &__mom-value {\n    font-size: 11px;\n    font-weight: 600;\n\n    &--positive {\n      color: $success;\n    }\n\n    &--negative {\n      color: $danger;\n    }\n  }\n}\n\n// Adaptive sparkline tooltip positioning: stay inside viewport on all breakpoints.\n.web-analytics-kpi-dashboard .recharts-tooltip-wrapper {\n  outline: none;\n  z-index: 60;\n  transform: translate(10px, calc(-100% + 14px)) !important;\n  transform-origin: left bottom;\n  pointer-events: none;\n}\n\n/* 4-column KPI grid (desktop): right-half cards open inward (to the left). */\n@media (min-width: 1201px) {\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n) .recharts-tooltip-wrapper,\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n - 1) .recharts-tooltip-wrapper {\n    transform: translate(calc(-100% - 10px), calc(-100% + 14px)) !important;\n    transform-origin: right bottom;\n  }\n}\n\n/* 2-column KPI grid (tablet/small laptop): second column opens inward. */\n@media (min-width: 601px) and (max-width: 1200px) {\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n) .recharts-tooltip-wrapper {\n    transform: translate(calc(-100% - 10px), calc(-100% + 14px)) !important;\n    transform-origin: right bottom;\n  }\n\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n + 1) .recharts-tooltip-wrapper {\n    transform: translate(8px, calc(-100% + 14px)) !important;\n    transform-origin: left bottom;\n  }\n}\n\n/* 1-column KPI grid (mobile): keep tooltip inside with compact offset. */\n@media (max-width: 600px) {\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card .recharts-tooltip-wrapper {\n    transform: translate(6px, calc(-100% + 22px)) !important;\n    transform-origin: left bottom;\n  }\n}\n\n.web-analytics-kpi-dashboard .kpi-graph-tooltip {\n  z-index: 10;\n  pointer-events: none;\n}\n\n.web-analytics-kpi-dashboard .recharts-default-tooltip {\n  padding: 0 !important;\n  background: transparent !important;\n  border: none !important;\n}\n\n.kpi-card__hover-title {\n  font-size: $font-size-sm;\n  font-weight: 700;\n  color: $brand-primary;\n}\n\n.kpi-card__hover-value {\n  font-size: $font-size-sm;\n  font-weight: 700;\n  color: $brand-primary;\n}\n\n.kpi-card__hover-period {\n  font-size: $font-size-xs;\n  color: $brand-primary;\n}\n\n.kpi-card__hover-divider {\n  border-top: 1px dashed $brand-primary;\n}\n\n.kpi-card__hover-mom-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: $font-size-xs;\n}\n\n.kpi-card__hover-mom-label {\n  color: $brand-primary;\n}\n\n.kpi-card__hover-change {\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: $font-size-xs;\n}\n\n.kpi-card__hover-change--positive {\n  color: #16a34a;\n}\n\n.kpi-card__hover-change--negative {\n  color: #dc2626;\n}\n\n.kpi-card__hover-comparison {\n  font-size: $font-size-xs;\n  color: $brand-primary;\n  font-weight: 700;\n  margin-top: 0;\n}\n\n.kpi-card__hover-content .kpi-card__hover-comparison:last-child {\n  margin-bottom: 6px;\n}\n\n/* Keep KPI hover panel and sparkline tooltip inside viewport on medium/small screens */\n.web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n) .kpi-card__hover-panel {\n  left: auto;\n  right: 0;\n}\n\n@media (max-width: 1000px) {\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card .kpi-card__hover-panel {\n    width: min(250px, calc(100vw - 190px));\n  }\n}\n\n/* Keep ? tooltip inside viewport by opening inward on right-side cards */\n.web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(2n) .kpi-card__definition-tooltip {\n  left: auto;\n  right: 0;\n}\n\n@media (min-width: 1201px) {\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n) .kpi-card__definition-tooltip,\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card:nth-child(4n - 1) .kpi-card__definition-tooltip {\n    left: auto;\n    right: 0;\n  }\n}\n\n@media (max-width: 600px) {\n  .web-analytics-kpi-dashboard .kpi-grid > .kpi-card .kpi-card__definition-tooltip {\n    left: 0;\n    right: auto;\n    max-width: calc(100vw - 28px);\n  }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
